
import { GolfBase } from './Golf-Base';
import { iphoneRedeemCode, iphoneGolfStore } from '../../link-actions';
import { getPromo } from '../../promos';

import Carousel from "react-multi-carousel";
import { PromoHeading } from '../promoMidSection';

const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        }
    };

export const GolfHome = () => {
    const sportKey = "golf";
    const promo = getPromo(sportKey);
    return (<GolfBase 
                banner={
                    <section className="atf-hero-area atf-shape black-smoke-background" style={{ background: 'linear-gradient(to bottom, transparent, transparent, rgba(255,255,255,1)), url(./assets/img/smokebg_dark.png)' }}>
                        <div className="non-landing-banner-clear"></div>
                            <div className="container">
                                
                                <div className="row justify-content-center clearfix">
                                        <div className="d-none d-lg-block col-lg-8 col-0 text-center align-self-center atf-single-details pt-3">
                                            <h2 style={{ marginTop: '30px', marginBottom: '0px', color:"white", fontFamily: 'Comfortaa' }}>Fast swing feedback</h2>
                                            <h2 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>for fast improvement</h2>
                                            <div className="mt-5">
                                                <PromoHeading promo={promo} />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-12 text-center atf-single-details pb-3">
                                        <div className="d-none d-lg-block" style={{height:'20px'}}></div>
                                        <h2 className="heading-size d-block d-lg-none" style={{ marginTop: '30px', color:"white", fontFamily: 'Comfortaa', paddingTop: '10px' }}>Fast swing feedback</h2>
                                        <h2 className="d-block d-lg-none" style={{ margin: '0px', marginBottom: '10px',  color:"yellowgreen", fontFamily: 'Comfortaa' }}>for fast improvement</h2>
                                                                                        
                                        <Carousel
                                            swipeable={true}
                                            draggable={true}
                                            showDots={true}
                                            responsive={responsive}
                                            infinite={true}
                                            autoPlay={true}
                                            autoPlaySpeed={2500}
                                            keyBoardControl={true}
                                            customTransition="transform 300ms ease-in-out"
                                            transitionDuration={500}
                                            containerClass="carousel-container"
                                            dotListClass="custom-dot-list-style"
                                            itemClass="carousel-item-padding-40-px"
                                        >
                                            <div className="px-1" >
                                                <div className="hero-caption" style={{top: '57%'}}>
                                                    <div style={{ margin: '0px 0px 0px 0px', color:"white", fontFamily: 'Comfortaa' }}>Real-time analysis</div>
                                                </div>
                                                <img className="hero-carousel-img" src="./assets/img/golf/analyse.png" alt="Real-time analysis" />
                                            </div>
                                            <div className="px-1">
                                                <div className="hero-caption" style={{top: '39%'}}>
                                                    <div style={{ margin: '0px 0px 0px 0px', color:"white", fontFamily: 'Comfortaa' }}>Slow motion<br />instant replays</div>
                                                </div>
                                                <img className="hero-carousel-img" src="./assets/img/golf/replay.png" alt="Slow motion instant replays"  />
                                            </div>
                                            <div className="px-1" >
                                                <div className="hero-caption" style={{top: '58%'}}>
                                                    <div style={{ margin: '0px 0px 0px 0px', color:"white", fontFamily: 'Comfortaa'}}>Auto pause and save</div>
                                                </div>
                                                <img className="hero-carousel-img" src="./assets/img/golf/pause.png" alt="Auto pause at key frames" />
                                            </div>
                                            <div className="px-1">
                                                <div className="hero-caption" style={{top: '37%'}}>
                                                    <div style={{ margin: '0px 0px 0px 0px', color:"white", fontFamily: 'Comfortaa' }}>Cast to tablet or laptop</div>
                                                </div>
                                                <img className="hero-carousel-img" style={{boxShadow: 'none', border: 'none'}} src="./assets/img/golf/cast.png" alt="Cast to tablet or laptop"/>
                                            </div>
                                        </Carousel>
                                        </div>
                                    </div>
                                    <div className="d-block d-lg-none row justify-content-center clearfix mt-4">
                                        <div className="text-center align-self-center p-2">
                                            <PromoHeading promo={promo} />
                                        </div>
                                </div>
                            </div>
                        </section>
                }
                />
    
    );
}

export default GolfHome;